export const states = {
    SIGNED_IN: 'SignedIn',
    SIGN_OFF: 'SignedOff',
    MANUAL_SIGN_OFF: 'ManualSignOff'
  }

export const loginExpired = {
  message: 'Invalid auth token'
}
